/* eslint-disable */

import { Button, Card, Space, Tabs, TabsProps, Typography } from "antd";
import React, { useEffect, useState } from "react";
import "./index.css";
import UserPolicy from "./UserPolicy";
import { useNavigate } from "react-router-dom";
import Private from "./Private";
import { useLocation } from "react-router-dom";

const { Title, Paragraph, Text, Link } = Typography;

const DOCS: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [activeKey, setActiveKey] = useState<string>("userpolicy");

	useEffect(() => {
		const segments = location.search.split("=");
		if (segments[segments.length - 1] != "docs") {
			setActiveKey(segments[segments.length - 1]);
		}
	}, [location]);

	const items: TabsProps["items"] = [
		{
			key: "userpolicy",
			label: "用户协议",
			children: <UserPolicy />,
		},
		{
			key: "privacy",
			label: "隐私协议 ",
			children: <Private />,
		},
	];

	const onChange = (key: string) => {
		setActiveKey(key);
	};

	return (
		<div className="docs">
			<Button
				style={{ float: "right" }}
				onClick={() => {
					navigate("/login");
				}}
			>
				BACK
			</Button>
			<Tabs activeKey={activeKey} items={items} onChange={onChange} />
		</div>
	);
};

export default DOCS;
